const TokenKey = 'jiazhiToken'
export default {
    getToken: function () {
        return localStorage.getItem(TokenKey)
    },
    setToken: function (token) {
        return localStorage.setItem(TokenKey, token)
    },
    // setuuid: function (uuid) {
    //     return localStorage.setItem("uuid", uuid)
    // },
    // getuuid: function () {
    //     return localStorage.getItem("uuid")
    // },
    removeToken: function () {
        localStorage.removeItem("jz_username");
        localStorage.removeItem("jz_relname");
        localStorage.removeItem("jz_cmpid");
        localStorage.removeItem("jz_roles");
        localStorage.removeItem("jz_menus");
        localStorage.removeItem("jz_userid");
        localStorage.removeItem(TokenKey);
        localStorage.removeItem("jz_type");
        localStorage.removeItem("jz_isCertification");
    },
    objSetToken: function (entity) {
        entity.sessionToken = this.getToken();
        entity.token=this.getToken();
    },
    gettype() {
        return localStorage.getItem("jz_type");
    },
    getisCertification() {
        return localStorage.getItem("jz_isCertification");
    },
    getusername() {
        return localStorage.getItem("jz_username");
    },
    getrelname() {
        return localStorage.getItem("jz_relname");
    },
    getcmpid() {
        return localStorage.getItem("jz_cmpid");
    },
    getRoles() {
        return JSON.parse(localStorage.getItem("jz_roles"));
    },
    getMenus() {
        return JSON.parse(localStorage.getItem("jz_menus"));
    }
};



// WEBPACK FOOTER //
// ./src/utils/auth.js